import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const ArticleHeading = styled(Box)`
  width: 100%;
  margin-top: ${props => props.theme.global.edgeSize.small};
  margin-bottom: ${props => props.theme.global.edgeSize.small};
  padding-bottom: ${({ title }) => (title ? '6px' : '0px')};
  border-bottom: ${({ title }) => (title ? '1px solid #E0E0E0' : '')};
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  
  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin-top: ${props => props.theme.global.edgeSize.medium};
    margin-bottom: ${props => props.theme.global.edgeSize.medium};
  }
`

export default ArticleHeading
